export default "__VITE_ASSET__8d670abc__"